<template>
  <div class="base-report report-sales-month">
    <div class="filter">
      <el-form inline>
        <el-date-picker
          v-model="searchForm.from_date"
          type="month"
          size="mini"
          placeholder="開始月"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.to_date"
          type="month"
          size="mini"
          placeholder="終了月"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-button size="mini" type="primary" @click="fetchData" :disabled="isLoading">表示</el-button>
        <div style="float: right; padding-right: 20px;">
          <el-button v-show="$store.getters.isPC && screenData.length>0" size="mini" type="success" icon="el-icon-download" @click="exportCSV">ダウンロード</el-button>
        </div>
      </el-form>
    </div>
    <div class="table_data" v-loading="isLoading">
      <template v-if="screenData.length>0">
        <el-table
          :data="screenData"
          border
          stripe
          :span-method="shopSpanMethod"
          height="100%">
          <template v-for="(header, index) in tableSetting">
            <template v-if="!Array.isArray(header)">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template v-if="Array.isArray(tableSetting[index + 1])">
                  <template v-for="(subheader, subindex) in tableSetting[index + 1]">
                    <el-table-column
                    :key="subheader.prop + subindex"
                    :label=subheader.label
                    :prop=subheader.prop
                    :min-width=subheader.width
                    :align=subheader.align
                    :sortable=subheader.sortable
                    :formatter="formatter">
                    </el-table-column>
                  </template>
                </template>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </template>
      <div v-else v-show="noData">
        データがありません。<br>
        条件を変えて再度「表示」ボタンを押してください。
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import addFigure from '@/misc/addFigure.js'
import downloadCSV from '@/misc/downloadCSV.js'
import {mapGetters} from 'vuex'

export default {
  name: 'ReportSalesMonth',
  data () {
    return {
      ratioStr: null,
      isLoading: false,
      noData: false,
      staticSetting: [
        {label: '店舗', prop: 'shopName', align: 'left', fixed: true, width: '200px'},
        {label: '項目／年月', prop: 'itemName', align: 'left', fixed: true, width: '130px'},
        {label: '合計', prop: 'total', align: 'right', width: '130px'},
      ],
      monthColumn: {label: 'YYYY年MM月', prop: 'month', align: 'right', width: '130px'},
      tableSetting: [],
      searchForm: {
        from_date: null,
        to_date: null,
      },
      itemList: [
        {'key': 'salesExcludeTaxNow', 'name': '当年'},
        {'key': 'salesExcludeTaxLastyear', 'name': '前年'},
        {'key': 'salesExcludeTaxPer', 'name': '前年比'},
        {'key': 'budgetNow', 'name': '予算'},
        {'key': 'budgetPer', 'name': '予算比'},
      ],
      orgData: [],
      screenData: [],
      totalData: [],
      form: {},
      minMonthColum: 4,
      csv_filename: '月別売上分析.csv',
    }
  },
  computed: {
    ...mapGetters('account', [
      'isGroupMode',
    ]),
    ...mapGetters('report', ['ratioStrFunction']),
  },
  watch: {
    isGroupMode (val) {
      if (!val) {
        this.$router.push({name: 'Home'})
      }
    },
  },
  created () {
    this.ratioStr = this.ratioStrFunction
  },
  mounted () {
    this.searchForm.from_date = moment().date(1).format('YYYY-MM-DD')
    this.searchForm.to_date = moment().format('YYYY-MM-DD')
  },
  methods: {
    fetchData () {
      this.isLoading = true
      this.noData = false
      this.totalData = []
      this.orgData = []
      this.screenData = []
      this.tableSetting = _.cloneDeep(this.staticSetting)

      this.$request.reports.reportShopSalesMonth(this.searchForm.from_date, this.searchForm.to_date).then(res => {
        let data = res.body
        if (data.records) {
          for (let record of data.records) {
            this.orgData.push(record.data)
          }
          this.updateScreenData()
        }
      }, err => {
        const body = err.response.body
        this.$parent.$emit('requestError', [body])
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    },
    updateScreenData () {
      let startMonth = moment(this.searchForm.from_date).date(1)
      let endMonth = moment(this.searchForm.to_date).date(1)
      let monthList = []

      if (!startMonth.isValid() || !endMonth.isValid()) {
        return
      }

      if (startMonth.isSameOrBefore(endMonth)) {
        let i = 0
        while (!startMonth.isAfter(endMonth)) {
          let key = startMonth.format('YYYYMM')
          monthList.push(key)

          // update template
          this.monthColumn.prop = key
          this.monthColumn.label = startMonth.format('YYYY年MM月')
          this.tableSetting.push(_.cloneDeep(this.monthColumn))
          startMonth.add(1, 'months')
          i++
        }
        for (let j = 0; j < this.minMonthColum - i; j++) {
          this.monthColumn.prop = 'padding' + j
          this.monthColumn.label = ''
          this.tableSetting.push(_.cloneDeep(this.monthColumn))
        }
      }

      for (let data of this.orgData) {
        for (let item of this.itemList) {
          let tmp = {}
          tmp['rowKey'] = item.key
          tmp['shopName'] = data.shopName
          tmp['itemName'] = item.name
          tmp['total'] = data['total'][item.key]
          for (let month of monthList) {
            tmp[month] = data[month][item.key]
          }
          this.screenData.push(tmp)
        }
      }
    },
    exportCSV () {
      let header = []
      let keyList = []
      for (let tableHeader of this.tableSetting) {
        if (Array.isArray(tableHeader)) {
          let preHeader = header.pop()
          for (let subHeader of tableHeader) {
            if (subHeader.prop) {
              keyList.push(subHeader.prop)
            }
            header.push(`${preHeader}-${subHeader.label}`)
          }
        } else {
          // check padding
          if (/^padding\d+/.test(tableHeader.prop)) {
            continue
          }
          if (tableHeader.prop) {
            keyList.push(tableHeader.prop)
          }
          header.push(tableHeader.label)
        }
      }

      let data = []
      for (let record of this.screenData) {
        let tmp = []
        for (let key of keyList) {
          let value = record[key]
          if (key !== 'shopName' && key !== 'itemName') {
            value = this.formatData(record.rowKey, record[key])
          }
          tmp.push(value)
        }
        data.push(tmp)
      }

      downloadCSV(this.csv_filename, header, data, this.totalData)
    },
    shopSpanMethod ({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0) {
        if (rowIndex % this.itemList.length === 0) {
          return {rowspan: this.itemList.length, colspan: 1}
        } else {
          return {rowspan: 0, colspan: 0}
        }
      }
    },
    formatter (row, column) {
      if (column.property === 'shopName' || column.property === 'itemName') {
        return row[column.property]
      }
      let key = row.rowKey
      return this.formatData(key, row[column.property])
    },
    formatData (key, value) {
      switch (key) {
        case 'salesExcludeTaxPer':
          return this.ratioStr(value)
        case 'budgetPer':
          return this.ratioStr(value)
        default:
          return addFigure(parseInt(value))
      }
    },
  },
}
</script>

<style lang="sass">
@import "static/sass/report/common.sass"
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportSalesMonth.vue